"use client"

import { FloatingNav } from "@/components/ui/FloatingNavbar"
import { HeroSection } from "@/components/home/hero-section"
import { MethodologySection } from "@/components/home/methodology-section"
import { EntitiesSection } from "@/components/home/entities-section"
import { ApproachSection } from "@/components/home/approach-section"
import { CTASection } from "@/components/home/cta-section"
import { SiteFooter } from "@/components/layout/site-footer"
import { CookieConsent } from "@/components/ui/cookie-consent"

export default function HomePage() {
  return (
    <>
      <FloatingNav />
      
      <main className="relative w-full bg-background">
        {/* Hero - full width with internal constraints */}
        <HeroSection />
        
        {/* Content sections - max-width container */}
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* How We Deliver Value - Services overview */}
          <EntitiesSection />
          {/* How We Work - Engagement phases */}
          <ApproachSection />
          {/* Our Methodology - Core pillars */}
          <MethodologySection />
          {/* CTA */}
          <CTASection />
        </div>
        
        {/* Footer - full width */}
        <footer className="w-full border-t border-border bg-card/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SiteFooter />
          </div>
        </footer>
      </main>
      
      <CookieConsent />
    </>
  )
}
